import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const EditorialPublic = () => {
  const [dataList, setDataList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState<any>(null);
  const token = Cookies.get("token");
  const [selected, setSelected] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await axios.get(`${API_BASE}/api/editorial/public/me`, {
        params: {
          page,
          per_page: 10,
        },
      });

      setDataList(res.data.data);
      setMeta(res.data.meta);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const openDetail = (item: any) => {
    setSelected(item);
    setShowModal(true);
  };

  const approve = async (id: number) => {
    try {
      await axios.put(
        `${API_BASE}/api/editorial/approve/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowModal(false);
      fetchData();
    } catch (err) {
      console.error("Gagal approve:", err);
    }
  };

  const reject = async (id: number) => {
    try {
      await axios.put(
        `${API_BASE}/api/editorial/reject/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setShowModal(false);
      fetchData();
    } catch (err) {
      console.error("Gagal reject:", err);
    }
  };

  return (
    <div className="mt-6">
      <h2 className="text-2xl font-bold text-primary mb-4">Moderasi Editorial Public</h2>

      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full text-sm">
          <thead className="bg-primary text-white">
            <tr>
              <th className="p-3 text-left">Judul</th>
              <th className="p-3 text-left">Author</th>
              <th className="p-3 text-left">Kategori</th>
              <th className="p-3 text-left">Kategori Web</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Tanggal</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : (
              dataList.map((item) => (
                <tr key={item.id} className="border-t hover:bg-orange-50">
                  <td className="p-3 font-medium">{item.judul.length > 30 ? item.judul.substring(0, 30) + "..." : item.judul}</td>

                  <td className="p-3">{item.author}</td>

                  <td className="p-3">
                    <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs">{item.kategori}</span>
                  </td>
                  <td className="p-3">{item.kategori_web}</td>

                  <td className="p-3">
                    <span className={`px-2 py-1 text-xs rounded capitalize ${item.status === "approved" ? "bg-green-100 text-green-700" : item.status === "rejected" ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700"}`}>
                      {item.status}
                    </span>
                  </td>

                  <td className="p-3">{new Date(item.created_at).toLocaleDateString()}</td>

                  <td className="p-3">
                    <button onClick={() => openDetail(item)} className="text-primary hover:underline">
                      Detail
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {meta && (
        <div className="flex justify-end gap-3 mt-4">
          <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 border rounded disabled:opacity-40">
            Prev
          </button>

          <button disabled={page === meta.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 border rounded disabled:opacity-40">
            Next
          </button>
        </div>
      )}

      {/* MODAL DETAIL */}
      {showModal && selected && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-[700px] max-h-[90vh] overflow-auto rounded-2xl shadow-xl p-6">
            <h3 className="text-xl font-bold mb-3">{selected.judul}</h3>

            {selected.gambar && <img alt="" src={selected.gambar} className="w-full h-64 object-cover rounded-lg mb-4" />}

            <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
              <div>
                <b>Author</b>
                <p>{selected.author}</p>
              </div>

              <div>
                <b>Kategori</b>
                <p>{selected.kategori}</p>
              </div>

              <div>
                <b>Status</b>
                <p className="capitalize">{selected.status}</p>
              </div>
            </div>

            <div className="text-gray-700 mt-2 prose max-w-none" dangerouslySetInnerHTML={{ __html: selected.deskripsi }} />

            <div className="flex justify-end gap-3">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 border rounded-lg">
                Tutup
              </button>

              <button onClick={() => reject(selected.id)} className="px-4 py-2 bg-red-500 text-white rounded-lg">
                Tolak
              </button>

              <button onClick={() => approve(selected.id)} className="px-4 py-2 bg-green-600 text-white rounded-lg">
                Approve
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditorialPublic;
